module.exports = __webpack_public_path__ + "static/img/fgbg1-9.f284644.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/fgbg1-9.png
// module id = 187
// module chunks = 0